export const REFUND_REPORTS_REQUESTING = 'refundReports/REQUESTING';
export const REFUND_REPORTS_SUCCESS = 'refundReports/SUCCESS';
export const REFUND_REPORTS_ERROR = 'refundReports/ERROR';

export const GENERATING_REPORT_REQUESTING =
	'refundReports/GENERATING_REPORT_REQUESTING';
export const GENERATING_REPORT_SUCCESS =
	'refundReports/GENERATING_REPORT_SUCCESS';
export const GENERATING_REPORT_ERROR = 'refundReports/GENERATING_REPORT_ERROR';
